const getter = (dataPath, {serviceTopology}) => {
    const baseUrl = serviceTopology.scriptsLocationMap['universal-editor-app']
    return `${baseUrl}/editorApp.bundle.min.js`
}

export default getter
